import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Reset scroll position to the top whenever the route changes
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 'instant' overrides the global smooth scroll-behavior so the new page doesn't animate up
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
